import { render, staticRenderFns } from "./InventoryData.vue?vue&type=template&id=0cc1b71a&scoped=true&"
import script from "./InventoryData.vue?vue&type=script&lang=js&"
export * from "./InventoryData.vue?vue&type=script&lang=js&"
import style0 from "./InventoryData.vue?vue&type=style&index=0&id=0cc1b71a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1b71a",
  null
  
)

export default component.exports